import { ClientFacingErrorContent } from '@/shared/types/errors/client-facing-error';

export const isClientFacingErrorContent = (error: unknown): error is ClientFacingErrorContent => {
  const { type, l18nMessage } = error as ClientFacingErrorContent;
  return !!type && !!l18nMessage;
};
